import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

/**
 * Interceptor que remove o sufixo 'Z' (UTC) das datas ISO retornadas pelo backend
 * para evitar conversão de fuso horário que causa exibição de datas incorretas.
 * 
 * Exemplo: "2025-01-01T00:00:00.000Z" -> "2025-01-01T00:00:00.000"
 */
@Injectable()
export class DateInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      map(event => {
        if (event instanceof HttpResponse) {
          return event.clone({
            body: this.convertDates(event.body)
          });
        }
        return event;
      })
    );
  }

  private convertDates(obj: any): any {
    if (!obj) return obj;
    
    // Se for um array, processar cada item
    if (Array.isArray(obj)) {
      return obj.map(item => this.convertDates(item));
    }
    
    // Se for um objeto, processar cada propriedade
    if (typeof obj === 'object') {
      for (const key of Object.keys(obj)) {
        const value = obj[key];
        if (this.isIsoDateString(value)) {
          // Remove Z para tratar como horário local
          obj[key] = value.replace('Z', '');
        } else if (typeof value === 'object') {
          obj[key] = this.convertDates(value);
        }
      }
    }
    
    return obj;
  }

  private isIsoDateString(value: any): boolean {
    return typeof value === 'string' && 
           /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{3}Z$/.test(value);
  }
}




